var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#434343",
    className: "fill-000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.4 50.5 9.9-9.9c.4-.4.4-1 0-1.4l-8.5-8.5c-.4-.4-1-.4-1.4 0l-9.9 9.9 9.9 9.9zM74.6 43.5 38 80.1l-4.4 13c-.3.8.5 1.5 1.3 1.3l13-4.4 36.6-36.6-9.9-9.9z",
    fill: "#ffffff",
    className: "fill-ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.8c39ce0df206c725f57f26f76e161745.svg";
export { ForwardRef as ReactComponent };